export const STORAGE_KEYS = {
  accessToken: "accessToken",
  refreshToken: "refreshToken"
} as const;
